import React from 'react';
import PropTypes from 'prop-types';
import SMCPageLoading from '../core/pageComponents/SMCPageLoading';

/**
 * LoadingContainer
 * Show loading page if loading=true, otherwise show children
 * @param {Object} props
 * @param {Boolean} props.loading
 * @param {Node} props.children
 */
function LoadingContainer({
    loading,
    children
}) {
    return (
        <>
        {loading && <SMCPageLoading />}
        <div style={{ display: loading ? 'none' : undefined }}>
            {children}
        </div>
        </>
    )
}

LoadingContainer.propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.node
}

export default LoadingContainer;